import * as yup from "yup";

export const registerSchema = yup.object({
  firstName: yup.string().required("validation.required"),
  lastName: yup.string().required("validation.required"),
  email: yup.string().email("validation.email").required("validation.required"),
  password: yup
    .string()
    .min(8, "validation.passwordMin")
    .required("validation.required"),
});

export const loginSchema = yup.object({
  email: yup.string().email("validation.email").required("validation.required"),
  password: yup.string().required("validation.required"),
});

export const otpSchema = yup.object({
  otp: yup.string().required("validation.required"),
});

export const forgotSchema = yup.object({
  email: yup.string().email("validation.email").required("validation.required"),
});

export const resetSchema = yup.object({
  email: yup.string().email("validation.email").required("validation.required"),
  otp: yup.string().required("validation.required"),
  newPassword: yup
    .string()
    .min(8, "validation.passwordMin")
    .required("validation.required"),
});
